import React, { memo } from 'react';
import Icon from '../../../components/AppIcon';

const HotelCard = memo(({ 
  hotel, 
  isSelected, 
  onSelect 
}) => {
  const handleClick = () => {
    onSelect(hotel);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className={`p-3 sm:p-4 rounded-xl border-2 cursor-pointer transition-all duration-200 ${
        isSelected
          ? 'border-blue-500 bg-blue-50 shadow-md'
          : 'border-slate-200 hover:border-blue-300 hover:bg-slate-50'
      }`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-pressed={isSelected}
      aria-label={`Selecionar hotel ${hotel.name}`}
    >
      <div className="flex items-start space-x-2 sm:space-x-3">
        <div className="w-8 h-8 sm:w-10 sm:h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name="Building2" size={16} color="var(--color-blue-600)" className="sm:hidden" />
          <Icon name="Building2" size={18} color="var(--color-blue-600)" className="hidden sm:block" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-slate-900 mb-1 truncate text-sm sm:text-base">
            {hotel.name}
          </h3>
          <p className="text-xs sm:text-sm text-slate-600 mb-2">
            <Icon name="MapPin" size={10} className="inline mr-1 sm:hidden" />
            <Icon name="MapPin" size={12} className="inline mr-1 hidden sm:inline" />
            {hotel.city}, {hotel.state}
          </p>
          <div className="flex items-center gap-2">
            <span className="text-xs text-slate-500 bg-slate-100 px-2 py-1 rounded">
              {hotel.code}
            </span>
          </div>
        </div>
        {isSelected && (
          <div className="flex-shrink-0">
            <div className="w-4 h-4 sm:w-5 sm:h-5 bg-blue-600 rounded-full flex items-center justify-center">
              <Icon name="Check" size={10} color="white" className="sm:hidden" />
              <Icon name="Check" size={12} color="white" className="hidden sm:block" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

HotelCard.displayName = 'HotelCard';

export default HotelCard;
